import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Toast } from '@/components/toast';
import { createContext, useCallback, useContext, useState } from 'react';
const ToastContext = createContext(undefined);
export const ToastProvider = ({ children, maxVisibleToasts = 3 }) => {
    const [toasts, setToasts] = useState([]);
    const removeToast = useCallback((toastId) => {
        setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== toastId));
    }, []);
    const showToast = useCallback(({ message, description, status, theme }) => {
        const id = Date.now();
        setToasts((prevToasts) => {
            const newToasts = [...prevToasts, { id, message, description, status, theme }];
            if (newToasts.length > maxVisibleToasts) {
                newToasts.shift();
            }
            return newToasts;
        });
        setTimeout(() => {
            removeToast(id);
        }, 5000);
    }, [maxVisibleToasts, removeToast]);
    const value = {
        showToast,
    };
    return (_jsxs(ToastContext.Provider, { value: value, children: [children, _jsx("div", { className: 'fixed right-2 z-100002 top-2', children: toasts.map((toast) => (_jsx(Toast, { id: toast.id, message: toast.message, description: toast.description, status: toast.status, removeToast: removeToast }, toast.id))) })] }));
};
export const useToast = () => {
    const context = useContext(ToastContext);
    if (context === undefined) {
        throw new Error('useToast must be used within a ToastProvider');
    }
    return context;
};
